import axios from "axios";
import router from "../router";
import toast from "../components/toast.js";
const service = axios.create({
  baseURL: "/dev-api",
  //http://182.92.217.183:9998
  //baseURL: "http://inm.soundpic.cn:9005/dev-api",
  //baseURL: "/adminApi",
  timeout: 600000,
});
service.defaults.headers.Accept = "application/json; charset=utf-8";
// Request interceptors
service.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("token")) {
      config.headers["Token"] = localStorage.getItem("token");
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptors
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code != 0) {
      toast.newToast(res.msg);
      if (res.code === 900001) {
        router.replace({
          path: "/login",
        });
      }
      return response.data;
    } else {
      return response.data;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
